import styled, { from, to } from 'theme';

export const PageHeaderWrapper = styled.div<{ meta: boolean }>`
  margin-bottom: ${props => (!props.meta ? '2.75rem;' : 0)};
  padding-bottom: 1.18rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  color: ${props => props.theme.variables.customColors.textColor};
  font-size: ${props => props.theme.variables.fonts.size.bigger3};
  font-family: ${props => props.theme.variables.typography.secondaryFont};

  ${to('md')} {
    justify-content: center;
    margin-bottom: ${props => (!props.meta ? '1rem;' : 0)};
    padding-bottom: 0;

    .page-header__actions {
      margin-top: 0.5rem;
    }
  }
`;

export const PageHeaderActions = styled.div`
  font-size: ${props => props.theme.variables.fonts.size.base};
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  margin: 0.3rem 0;

  ${to('md')} {
    margin-left: 0.75rem;
  }

  ${from('md')} {
    margin: 0.3rem 0 0.3rem auto;
  }
`;

export const PageHeaderMeta = styled.div`
  align-self: normal;
  flex: 0 0 100%;
  font-size: ${props => props.theme.variables.fonts.size.smaller1};
  font-family: ${props => props.theme.variables.typography.primaryFont};
  font-weight: ${props => props.theme.variables.fonts.weight.light};
  line-height: 1.25rem;
  color: ${props => props.theme.variables.customColors.lightBlue};
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  padding-left: 3rem;

  > * {
    margin-right: 1rem;
  }
`;
